var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPrevious = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2.5C2 2.22386 2.22386 2 2.5 2C2.77614 2 3 2.22386 3 2.5V13.5C3 13.7761 2.77614 14 2.5 14C2.22386 14 2 13.7761 2 13.5V2.5ZM13.9998 3.00176C13.9998 2.19 13.0836 1.71649 12.4214 2.18598L5.42102 7.14909C4.86127 7.54594 4.85834 8.37575 5.41528 8.77654L12.4157 13.8142C13.0772 14.2903 13.9998 13.8176 13.9998 13.0026V3.00176ZM5.99938 7.96486L12.9998 3.00176L12.9998 13.0026L5.99938 7.96486Z",
  fill: "#262626"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrevious, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/previous.a29768df.svg";
export { ForwardRef as ReactComponent };